import lodashGet from "lodash/get";
import React, { ComponentPropsWithoutRef } from "react";
import Badge from "shared/components/common/Badge";
import { PillarTableBaseColumnCellValuePathProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";
import { WorkflowInstanceView } from "shared/mappers/database/workflow/workflow-instance";
import { DeepKeys } from "shared/types/deepkeys";

export type PillarTableColumnWorkflowInstanceStatusProps<T> = {
  placeholder?: string;
} & PillarTableBaseColumnCellValuePathProps<T> &
  ComponentPropsWithoutRef<"div">;

const PillarTableColumnWorkflowInstanceStatus = <T,>({
  cellValuePath = "workflowInstance" as DeepKeys<T>,
  placeholder = "-",
  contentClassName,
  ...props
}: PillarTableColumnWorkflowInstanceStatusProps<T>) => {
  const rowContext = usePillarTableRowContext();
  const value: WorkflowInstanceView | undefined = lodashGet(
    rowContext?.rowValue,
    cellValuePath,
  ) as WorkflowInstanceView | undefined;

  if (!value) {
    return <></>;
  }

  return (
    <Badge
      className={`w-fit px-2 whitespace-normal break-words text-center ${value.displayStatus.className} ${contentClassName ?? ""}`}
    >
      <>{value.displayStatus.displayStatus}</>
    </Badge>
  );
};

PillarTableColumnWorkflowInstanceStatus.doNotExport = true;
export default PillarTableColumnWorkflowInstanceStatus;
